import Cta from "./Cta";
export default Cta;